<script lang="ts">
    import { getContainer } from '$components/Context/ContainerContext';
    import { createForm } from '$components/LoginForm/LoginFormData';
    import { createOnSubmit } from '$components/LoginForm/LoginFormAction';
    import Row from '$components/Form/Row.svelte';
    import SubmitButton from '$components/Form/SubmitButton.svelte';
    import HtmlForm from '$components/Form/HtmlForm.svelte';
    import PasswordInput from '$components/Form/PasswordInput.svelte';
    import FormErrors from '$components/Form/FormErrors.svelte';
    import Input from '$components/Form/Input.svelte';

    let [form, fields] = createForm('login-form-dropdown', {});

    export let targetPath: string | null = null;

    export let onSubmit = createOnSubmit({ targetPath: () => targetPath });

    const { urlHelper } = getContainer();
</script>

<div class="text-left">
    <div class="text-center">
        <h2>Connexion</h2>
    </div>

    <HtmlForm class="flex flex-col gap-8" {form} {onSubmit}>
        <h3 class="mb-4 font-bold text-16 text-center">Déjà inscrit ?</h3>

        <Row {form} field={fields.email} label="Email" let:field>
            <Input
                {form}
                {field}
                toText={(id) => id}
                fromText={(id) => id}
                name="email"
            />
        </Row>

        <Row {form} field={fields.password} label="Mot de passe" let:field>
            <PasswordInput {form} {field} name="password" />
        </Row>

        <FormErrors {form} />

        <div class="flex flex-col gap-4">
            <SubmitButton
                {form}
                class="btn btn-primary btn-lg btn-block self-start"
                text="Se connecter"
                submittingText="Connexion en cours..."
            />

            <a
                class="flex-auto text-12 text-link underline hover:no-underline py-4"
                href={urlHelper().resetPassword()}
                >Mot de passe oublié ?
            </a>
        </div>
    </HtmlForm>
</div>
